export default __webpack_public_path__ + "static/media/Msg_Kopinski_Img0030.339b3a95.jpg";